//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const BatchImport = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="BatchImport"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M8.32118 8.63867V13.7579C8.32118 14.0124 8.22006 14.2566 8.04005 14.4366C7.86004 14.6166 7.6159 14.7177 7.36133 14.7177C7.10676 14.7177 6.86262 14.6166 6.68261 14.4366C6.50261 14.2566 6.40148 14.0124 6.40148 13.7579V10.9583L1.64141 15.7168C1.55213 15.8061 1.44613 15.8769 1.32947 15.9252C1.21282 15.9735 1.08779 15.9984 0.961517 15.9984C0.835249 15.9984 0.710217 15.9735 0.59356 15.9252C0.476904 15.8769 0.370907 15.8061 0.281622 15.7168C0.192337 15.6275 0.121512 15.5215 0.0731911 15.4048C0.0248703 15.2882 0 15.1632 0 15.0369C0 14.9106 0.0248703 14.7856 0.0731911 14.6689C0.121512 14.5523 0.192337 14.4463 0.281622 14.357L5.04169 9.59852H2.24212C1.98755 9.59852 1.74341 9.49739 1.5634 9.31739C1.38339 9.13738 1.28227 8.89324 1.28227 8.63867C1.28227 8.3841 1.38339 8.13996 1.5634 7.95995C1.74341 7.77994 1.98755 7.67882 2.24212 7.67882H7.36133C7.6159 7.67882 7.86004 7.77994 8.04005 7.95995C8.22006 8.13996 8.32118 8.3841 8.32118 8.63867ZM14.4002 0H4.16182C3.73754 0 3.33064 0.168545 3.03063 0.468557C2.73062 0.768569 2.56207 1.17547 2.56207 1.59975V5.11921C2.56207 5.37378 2.6632 5.61792 2.8432 5.79793C3.02321 5.97794 3.26735 6.07906 3.52192 6.07906C3.77649 6.07906 4.02063 5.97794 4.20064 5.79793C4.38065 5.61792 4.48177 5.37378 4.48177 5.11921V1.9197H14.0803V11.5182H10.8808C10.6262 11.5182 10.3821 11.6194 10.2021 11.7994C10.0221 11.9794 9.92094 12.2235 9.92094 12.4781C9.92094 12.7326 10.0221 12.9768 10.2021 13.1568C10.3821 13.3368 10.6262 13.4379 10.8808 13.4379H14.4002C14.8245 13.4379 15.2314 13.2694 15.5314 12.9694C15.8315 12.6694 16 12.2625 16 11.8382V1.59975C16 1.17547 15.8315 0.768569 15.5314 0.468557C15.2314 0.168545 14.8245 0 14.4002 0Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
